import { orderedRouteList } from './routeDefinitions';
import { type RouteIdType } from './RouteId';

/**
 * Returns the route id of a provided URL pathname.
 *
 * @example
 * // returns 'powerUpPublicDirectory'
 * getRouteIdFromPathname('/power-ups');
 *
 * @param path - The path to get the route id from
 * @returns The route id
 * @throws {Error} If path name did not match any route ID.
 */
export const getRouteIdFromPathname = (path: string): RouteIdType => {
  // Remove the leading slash if present
  const pathWithoutLeadingSlash = path.startsWith('/')
    ? path.substring(1)
    : path;

  // Remove any query params
  const normalizedPath = pathWithoutLeadingSlash.replace(/\?(.*)$/, '');

  for (const route of orderedRouteList) {
    if (normalizedPath.match(route.regExp)) {
      return route.id;
    }
  }

  throw new Error('Path name did not match any Route ID');
};
